import Swal from 'sweetalert2';
import React from 'react';
import ActionValidatorModal from '@common/components/modals/actionValidator.modal';
import { ModalManager } from '@common/helpers/modal.helper';
import _ from 'lodash';
import TopFix from '@common/helpers/topFix.helper';

const Toast = Swal.mixin({
  allowOutsideClick: false,
});

window._alert = {
  success(message, title) {
    Toast.fire({ type: 'success', titleText: title || 'Sucesso!', html: message, onAfterClose: () => TopFix.topFix() });
  },
  successNoScroll(message, title) {
    Toast.fire({ type: 'success', titleText: title || 'Sucesso!', html: message });
  },
  updatedPromise(title) {
    return new Promise((resolve) => {
      Toast.fire({
        type: 'success',
        titleText: title || 'Sucesso!',
        html: 'Registro alterado com sucesso.',
        onAfterClose: () => TopFix.topFix(),
      }).then(resolve);
    });
  },
  error(message, title) {
    Toast.fire(title || 'Erro!', message, 'error');
  },
  errorPromise(message, title) {
    return new Promise((resolve) => {
      Toast.fire(title || 'Erro!', message, 'error').then(resolve);
    });
  },
  warning(message, title) {
    Toast.fire(title || 'Atenção!', message, 'warning');
  },
  warningPromise(message, title) {
    return new Promise((resolve) => {
      Toast.fire(title || 'Atenção!', message, 'warning').then(resolve);
    });
  },
  warningSuccess(message, title) {
    return new Promise((resolve) => {
      Toast.fire(title || 'Sucesso!', message, 'success').then(resolve);
    });
  },
  warningTop(message, title) {
    Toast.fire({ type: 'warning', titleText: title || 'Atenção!', html: message, onAfterClose: () => TopFix.topFix() });
  },
  info(message, title) {
    Toast.fire(title || 'Atenção!', message, 'info');
  },
  confirm(message, title, html, hasCancel) {
    return new Promise((resolve) => {
      ModalManager.open(
        <ActionValidatorModal title={title} message={message} html={html} onConfirm={resolve} hasCancel={hasCancel} />
      );
    });
  },
};

window._showError = (error) => {
  _alert.error(
    !error
      ? 'Ocorreu um erro indefinido.'
      : _.isString(error)
      ? error
      : error.response
      ? error.response.data || error.response.data.ExceptionMessage || error.response.data.Message
      : error.message || error.ExceptionMessage || error.Message || JSON.stringify(error)
  );
};
